import { Toast } from "vant";
export default {
  /**
   * 时间戳转换年月日
   */
  formattedDate(timestamp) {
    const date = new Date(timestamp * 1000);
    const options = { year: "numeric", month: "2-digit", day: "2-digit" };
    return date.toLocaleDateString("zh-CN", options);
  },
  /**
   * 手机号中间加*号
   */
  maskedString(originalString) {
    return originalString.replace(/(\d{3})(\d{4})(\d{4})/, "$1****$3");
  },

  /**
   * 提示
   */
  showToast( message, type = 'fail' ,duration = 1000,) {
    if (type === 'success') {
        Toast.success({
            duration: duration,
            message: message,
        });
    } else {
        Toast.fail({
            duration: duration,
            message: message,
        });
    }
  },


  forData(timestamp) {
    const date = new Date(timestamp * 1000);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`; // 返回格式化后的日期
},
addStyleToParagraphs(content) {
  if (!content) return "";
  return content.replace(/<p([^>]*)>/g, (match, p1) => {
    if (p1.includes('style="')) {
      // 如果已经有 style 属性，追加 'text-transform: none;' 到已有样式中
      return match.replace(/style="([^"]*)"/, (styleMatch, styles) => {
        return `style="${styles}; text-transform: none;"`; // 在已有的样式后添加
      });
    }

    // 如果没有 style 属性，直接添加 style="text-transform: none;"
    return `<p${p1} style="text-transform: none;">`;
  });
}

};



// WEBPACK FOOTER //
// ./src/utils/base.js